module.exports = __webpack_public_path__ + "static/media/invenio.4d15de33.jpeg";